import { z } from 'zod/v4';

/**
 * HTTP-boundary input for `PUT /integrations/amfori/credentials`.
 *
 * Distinct from `AmforiCredentialsUpsertInputSchema` (the service-boundary
 * contract that REQUIRES `clientSecret`): the HTTP layer accepts an OPTIONAL
 * `clientSecret` to support "edit clientId only" flows where the previously
 * stored secret should be preserved.
 *
 * When `clientSecret` is absent, the backend keeps the currently persisted
 * encrypted secret and re-verifies using it.
 *
 * SECURITY: this schema is request-only. The plaintext secret never appears
 * in any response schema — see `AmforiCredentialsResourceSchema`.
 */
export const AmforiCredentialsUpdateInputSchema = z
  .object({
    clientId: z.string().min(1),
    clientSecret: z.string().min(1).optional(),
  })
  .strict();

export type AmforiCredentialsUpdateInput = z.infer<
  typeof AmforiCredentialsUpdateInputSchema
>;
